import React from "react";

import { useTranslation } from "react-i18next";

import useStyles, { Container, LeftContent } from "./styles";

interface FoldersListSectionTitleProps {
  isOnViewMode?: boolean;
  name?: string;
  allowedExtensions?: string[];
  rightAppend?: React.ReactNode;
}

export const FoldersListSectionTitle = (props: FoldersListSectionTitleProps) => {
  const { name, isOnViewMode, allowedExtensions, rightAppend } = props;
  const { t: translate } = useTranslation();
  const classes = useStyles();

  return (
    <Container className={isOnViewMode ? classes.w100 : ""}>
      <LeftContent>
        <span className={classes.title}>{name}</span>
        <p className={classes.validFormatLabel}>
          <span>{translate("validFormats")}:</span>

          <span className={classes.validFormatLabelDescription}>
            {allowedExtensions?.map(
              (extension, index: number) =>
                `${extension}${index < allowedExtensions.length - 1 ? ", " : ""}`
            )}
          </span>
        </p>
      </LeftContent>
      {rightAppend}
    </Container>
  );
};
